import React, { Key, useEffect, useState } from "react";
import styles from "./Input.module.scss";
import classNames from "classnames";
import { Select } from "../index";
import { Input as InputAntd } from "antd";

const cx = classNames.bind(styles);

export type InputProps = {
  shaperound?: boolean | string;
  mode?: "TextArea";
  [key: string]: any;
};

const { Option } = Select;

const Input = (props: InputProps) => {
  //Define constant
  const InputProps: InputProps = { shaperound: false, ...props };
  const hasAddon =
    (InputProps.addonAfter && InputProps.addonAfter.length > 0) ||
    (InputProps.addonBefore && InputProps.addonBefore.length > 0);
  const inputAntdProps = { ...InputProps };
  delete inputAntdProps.defaultValue;
  delete inputAntdProps.shaperound;
  delete inputAntdProps.option;
  delete inputAntdProps.defaultAddon;
  delete inputAntdProps.addonAfter;
  delete inputAntdProps.addonBefore;

  const addon = (type: string, key: string) => {
    return InputProps.defaultAddon && InputProps.defaultAddon[type][key]
      ? InputProps.defaultAddon[type][key]
      : type;
  };

  const defaultVal =
    InputProps.addonAfter &&
    InputProps.addonAfter.length > 0 &&
    InputProps.addonBefore &&
    InputProps.addonBefore.length > 0
      ? {
          value: undefined,
          [addon("addonAfter", "key")]: addon("addonAfter", "value")
            ? addon("addonAfter", "value")
            : undefined,
          [addon("addonBefore", "key")]: addon("addonBefore", "value")
            ? addon("addonBefore", "value")
            : undefined,
        }
      : InputProps.addonAfter && InputProps.addonAfter.length > 0
      ? {
          value: undefined,
          [addon("addonAfter", "key")]: addon("addonAfter", "value")
            ? addon("addonAfter", "value")
            : undefined,
        }
      : InputProps.addonBefore && InputProps.addonBefore.length > 0
      ? {
          value: undefined,
          [addon("addonBefore", "key")]: addon("addonBefore", "value")
            ? addon("addonBefore", "value")
            : undefined,
        }
      : "";

  const [input, setInput] = useState<any>(
    InputProps.value !== undefined
      ? InputProps.value
      : InputProps.defaultValue !== undefined
      ? InputProps.defaultValue
      : defaultVal,
  );

  //Function handle action
  const setForm = (key: string, value: any) => {
    InputProps.onChange && InputProps.onChange({ ...input, [key]: value });
    return setInput((oldValues: any) => ({
      ...oldValues,
      [key]: value,
    }));
  };

  const handleChangeAfter = (type: string, value: string) => {
    setForm(addon(type, "key"), value);
  };

  const handleChangeInput = (e: any) => {
    if (hasAddon) {
      setForm("value", e.target.value);
    } else {
      setInput(e.target.value);
      InputProps.onChange && InputProps.onChange(e.target.value);
    }
  };

  //Function hook
  useEffect(() => {
    if (InputProps.value !== undefined) {
      setInput(InputProps.value);
    }
  }, [InputProps.value]);

  //Function to render
  const renderSelectAfter = (type: string, option?: any) => {
    const inputAddonValue =
      input && typeof input === "object"
        ? input[
            InputProps.defaultAddon && InputProps.defaultAddon[type]?.key
              ? InputProps.defaultAddon[type].key
              : type
          ]
        : undefined;

    return option && option.length > 0 ? (
      <Select
        onChange={(e) => {
          handleChangeAfter(type, e);
        }}
        className={cx(type == "before" && styles.before)}
        defaultValue={inputAddonValue}
      >
        {option.map((item: any, key: Key) => {
          return (
            <Option value={item.value} key={key}>
              {item.label}
            </Option>
          );
        })}
      </Select>
    ) : (
      InputProps.option
    );
  };

  const inputValue = hasAddon ? input?.value ?? "" : input ?? "";
  const addonBeforeNode =
    InputProps.addonBefore && InputProps.addonBefore.length > 0
      ? renderSelectAfter("addonBefore", InputProps.addonBefore)
      : undefined;
  const addonAfterNode =
    InputProps.addonAfter && InputProps.addonAfter.length > 0
      ? renderSelectAfter("addonAfter", InputProps.addonAfter)
      : undefined;

  //Main render
  return (
    <InputAntd
      {...inputAntdProps}
      {...(addonBeforeNode !== undefined
        ? { addonBefore: addonBeforeNode }
        : {})}
      {...(addonAfterNode !== undefined ? { addonAfter: addonAfterNode } : {})}
      className={cx(
        (InputProps.shaperound == undefined || InputProps.shaperound) &&
          styles.shaperound,
        (InputProps.shaperound == undefined || InputProps.shaperound) &&
          !InputProps.prefix &&
          !InputProps.suffix &&
          styles.shaperoundPrefix,
        InputProps.className,
      )}
      // allowClear={true}
      onChange={handleChangeInput}
      value={inputValue}
    />
  );
};

export { Input };
